import {Directive, ElementRef, Input} from '@angular/core';
import {IEService} from "@ispm/shared/services/IE.service";


export const SYSTEM_DEFAULT_FONT_SIZE = 16;
export const MAX_FIELD_WIDTH =130;
const hyphensStyleIE: string = 'hyphens: auto; -ms-hyphens: auto;';
const hyphensStyle: string = 'word-break: break-word; word-wrap: break-word; hyphens: manual;';

@Directive({
  selector: '[gen-hyphens]'
})
export class HyphensDirective {

  @Input() shouldHyphenate: boolean = false;
  static isIE: boolean = undefined;
  private recheck: boolean = true;

  constructor(private element: ElementRef, private ieService: IEService) {

    if (HyphensDirective.isIE == undefined) {
      HyphensDirective.isIE = ieService.isIE();
    }
  }

  @Input() set reapply(shouldReapply) {
    this.recheck = !!shouldReapply;

    if (!!this.shouldHyphenate) {
      setTimeout(() => {
        //this.recheck = !!shouldReapply;
        if (this.recheck && this.shouldHyphenate) {
          this.check();
        }
      }, 0);
    }
  }

  public check() {
    const numbOfChildes = this.element.nativeElement.children.length;
    if (numbOfChildes > 0) {
      for (let i = 0; i < numbOfChildes; i++) {
        this.addHyphens(this.element.nativeElement.children[i]);
      }
    } else {
      this.addHyphens(this.element.nativeElement);
    }
  }

  addHyphens(element) {

    let text = element.innerHTML;
    if (!text) {
      return;
    }

    this.removeExistingShyHyphens(element);
    if (HyphensDirective.isIE) {
      let widthStr = window.getComputedStyle(element, null).getPropertyValue('width');
      let widthNum: number = MAX_FIELD_WIDTH;
      if (widthStr == 'auto')
        widthNum = MAX_FIELD_WIDTH;
      else {
        widthNum = Math.floor(parseFloat(widthStr));
        widthNum = !!widthNum ? widthNum : MAX_FIELD_WIDTH;
      }
      widthNum = Math.max(widthNum, MAX_FIELD_WIDTH);
      let fontSize = !this.getFontSize(element) ? SYSTEM_DEFAULT_FONT_SIZE : this.getFontSize(element);
      const maxLetters = Math.floor(widthNum / (fontSize * 1.4)); //need to consider spacing as well
      // slice text with max letters or space
      let longWords = this.sliceText(text, maxLetters);
      element.innerHTML = maxLetters > 0 ? longWords.map(word => this.hyphenateWord(word.replace(/ +$/, ''), maxLetters)).join(' ') : text;
      element.setAttribute('original-text', text);
      element.setAttribute("style", hyphensStyleIE + 'width:' + MAX_FIELD_WIDTH + 'px;');
    }
    else {
      element.setAttribute("style", hyphensStyle);
    }
  }

  sliceText(text: string, maxLetters: number) {

    if (text.length <= maxLetters)
      return [text];

    let words = text.split(' ');
    let longChunks = [];
    let chunk = '';
    for (let i = 0; i < words.length; i++) {
      if (chunk.length >= maxLetters) {
        longChunks.push(chunk);
        chunk = words[i] + ' ';
      }
      else {
        chunk += words[i] + ' ';
      }
    }

    longChunks.push(chunk);
    return longChunks;
  }

  getFontSize(element) {
    try {
      return parseFloat(window.getComputedStyle(element).getPropertyValue('font-size'));
    }
    catch (error) {
      return SYSTEM_DEFAULT_FONT_SIZE;
    }
  }

  private removeExistingShyHyphens(element: any) {
    element.innerHTML = element.innerHTML.replace(/\u00AD/g, '').replace(/\&shy;/gi, '');
  }

  private hyphenateWord(word: string, maxLetters: number) {
    if (word.length <= maxLetters) {
      return word;
    } else {

      return `${word.slice(0, maxLetters)}&shy;${this.hyphenateWord(word.slice(maxLetters, word.length), maxLetters)}`;
    }

  }
}
